<template>
  <div class="dkhgc">
    <div class="dkCon">
      <p class="dkCon_tit  wow fadeInUp">大客户购车</p>
       <div class="hmaBox">
        <img src="~@/assets/image/dkh_banner.jpg" class="act_banner" />
        <p class="dkhBox_p wow fadeInUp">欢迎关注菱势汽车集团大客户平台</p>
      </div>
      <!-- <div class="dkBox clearfix">
        <div class="dkBox_li  wow fadeInUp">
          <div class="dkBox_li_tp">
            <img src="~@/assets/image/cpic1.jpg" class="cpic1" />
          </div>
          <p class="dkBox_li_p  wow fadeInUp">政府购车</p>
        </div>
        <div class="dkBox_li">
          <div class="dkBox_li_tp  wow fadeInUp">
            <img src="~@/assets/image/cpic2.jpg" class="cpic1" />
          </div>
          <p class="dkBox_li_p  wow fadeInUp">企业购车</p>
        </div>
        <div class="dkBox_li">
          <div class="dkBox_li_tp  wow fadeInUp">
            <img src="~@/assets/image/cpic3.jpg" class="cpic1" />
          </div>
          <p class="dkBox_li_p  wow fadeInUp">平台购车</p>
        </div>
        <div class="dkBox_li">
          <div class="dkBox_li_tp  wow fadeInUp">
            <img src="~@/assets/image/cpic4.jpg" class="cpic1" />
          </div>
          <p class="dkBox_li_p  wow fadeInUp">物流购车</p>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { WOW } from 'wowjs'
  export default {
    data () {
      return {
      }
    },
    created () {
    },

    mounted () {
// 在项目加载完成之后初始化wow
    this.$nextTick(() => {
      let wow = new WOW({
        live: false,
      })
      wow.init()
    })
    },
    methods: {
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/home/keyAccount.vue